import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { Box } from 'transfix-ui/core'
import Skeleton from 'transfix-ui/core/Skeleton'

interface ILoadableValue {
  value?: Maybe<string | number> | boolean | React.FC | React.ReactNode
  loading?: boolean
  percent?: boolean
  color?: Maybe<string>
  fallback?: string
}

export const LoadableValue = ({
  color,
  fallback,
  loading = false,
  percent,
  value,
}: ILoadableValue) => {
  if (loading) {
    return <Skeleton variant='text' width={100} height={19} />
  }

  if (typeof value === 'boolean') {
    return (
      <Box color={color ?? ''}>
        <span>{value ? 'Yes' : 'No'}</span>
      </Box>
    )
  }

  if (value !== 0 && !value) {
    return (
      <Box color={color ?? ''}>
        <span>{fallback || 'No Data'}</span>
      </Box>
    )
  }

  return (
    <Box color={color ?? ''}>
      <span>
        {value}
        {percent ? '%' : ''}
      </span>
    </Box>
  )
}
